import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'
import { type BrokersEnrollmentWithPaymentsOrCoverages } from 'utils/web_api.schemas'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type GetBrokersMembersEnrollmentsQueryArgs = {
  memberId: string
}

export function getBrokersMembersEnrollmentsQueryKey ({
  memberId,
}: GetBrokersMembersEnrollmentsQueryArgs) {
  return ['brokers', 'members', memberId, 'enrollments', 'has_coverages_or_payments']
}

export function useGetBrokersMembersEnrollments ({
  memberId,
}: GetBrokersMembersEnrollmentsQueryArgs) {
  return useQuery<BrokersEnrollmentWithPaymentsOrCoverages[], GrapeAPIErrorType>({
    queryKey: getBrokersMembersEnrollmentsQueryKey({ memberId }),
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/brokers/members/${memberId}/enrollments/has_coverages_or_payments`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    retry: false,
  })
}
